import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { BiImage } from "react-icons/bi";

// Foto bukti kegiatan dari menu Akomodasi (/akomodasi/). Disimpan di kolom bukti JR (EvidenceUrl) sebagai
// penanda "akomodasi-foto:12,13" — bukan URL publik. Gambar dimuat lewat endpoint berizin saat tombol diklik.
const API = process.env.REACT_APP_API_URL;
const AWAL = "akomodasi-foto:";

export const adaFotoAkomodasi = (v) => typeof v === "string" && v.startsWith(AWAL);
const idFoto = (v) => v.slice(AWAL.length).split(",").map((x) => parseInt(x, 10)).filter(Boolean);

function headers() {
  const user = JSON.parse(localStorage.getItem("user"));
  return { Authorization: "Bearer " + user?.Token, Accept: "*/*" };
}

function Gambar({ id, onBuka }) {
  const [url, setUrl] = useState(null);
  const [gagal, setGagal] = useState(false);
  useEffect(() => {
    let batal = false;
    let objek = null;
    axios
      .get(API + "getAkomodasiFoto", { headers: headers(), params: { id }, responseType: "blob" })
      .then((res) => {
        if (batal) return;
        // Server membalas JSON galat (bukan gambar) bila ditolak: jangan dijadikan <img>.
        if (!String(res.data?.type || "").startsWith("image/")) {
          setGagal(true);
          return;
        }
        objek = URL.createObjectURL(res.data);
        setUrl(objek);
      })
      .catch(() => !batal && setGagal(true));
    return () => {
      batal = true;
      if (objek) URL.revokeObjectURL(objek);
    };
  }, [id]);
  if (gagal) return <div className="w-28 h-28 bg-gray-100 text-xs text-gray-500 flex items-center justify-center rounded">tidak dapat dimuat</div>;
  if (!url) return <div className="w-28 h-28 bg-gray-100 animate-pulse rounded" />;
  return <img src={url} alt="Bukti kegiatan" onClick={() => onBuka(url)} className="w-28 h-28 object-cover rounded cursor-zoom-in border" />;
}

// Tombol "Foto (n)"; klik membuka jendela berisi foto-foto, klik foto untuk memperbesar.
export default function FotoBuktiLink({ value }) {
  const [buka, setBuka] = useState(false);
  const [besar, setBesar] = useState(null);
  if (!adaFotoAkomodasi(value)) return null;
  const ids = idFoto(value);
  return (
    <>
      <button type="button" onClick={() => setBuka(true)} title="Lihat foto bukti dari Akomodasi"
        className="inline-flex items-center gap-1 text-purple-600 hover:text-purple-800 text-sm whitespace-nowrap">
        <BiImage /> Foto ({ids.length})
      </button>
      {buka && createPortal(
        <div className="fixed inset-0 z-[70] bg-black/60 flex items-center justify-center p-4" onClick={() => { setBuka(false); setBesar(null); }}>
          <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full max-h-[90vh] overflow-auto p-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-base font-semibold text-gray-800">Foto bukti kegiatan (Akomodasi)</h3>
              <button type="button" onClick={() => { setBuka(false); setBesar(null); }} className="text-2xl leading-none text-gray-500">×</button>
            </div>
            <div className="flex flex-wrap gap-2">
              {ids.map((id) => <Gambar key={id} id={id} onBuka={setBesar} />)}
            </div>
            <p className="text-xs text-gray-500 mt-3">Klik foto untuk memperbesar.</p>
          </div>
        </div>,
        document.body
      )}
      {besar && createPortal(
        <div className="fixed inset-0 z-[80] bg-black/85 flex items-center justify-center p-4" onClick={() => setBesar(null)}>
          <img src={besar} alt="Bukti kegiatan" className="max-w-full max-h-full rounded" />
        </div>,
        document.body
      )}
    </>
  );
}
